export const WATERMARK_DELAY_SECONDS = 3;
export const WATERMARK_LOOP_SECONDS = 8;

/** Output-timeline second the watermark appears: `delay` for normal clips, but
 *  never so late that a short clip escapes it — clips shorter than 2×delay show
 *  it for their last `delay` seconds, and clips ≤ delay show it throughout. */
export function resolveWatermarkStartSeconds(
  durationSeconds: number,
  delaySeconds: number = WATERMARK_DELAY_SECONDS,
): number {
  if (!(durationSeconds > 0)) return 0;
  const delay = Math.max(0, delaySeconds);
  return Math.min(delay, Math.max(0, durationSeconds - delay));
}
